import { useMemo } from "react";
import HydroPower from "./HydroPower";
import SolarPower from "./SolarPower";
import ThermalPower from "./ThermalPower";
import Loader from "../../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { setPowerTabStr } from "../../redux/slice/sliceHome";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const PowerGeneration = () => {
  const { getText } = useLanguageTranslation();
  const { powerTabStr, languageType } = useSelector((state) => state.homeSlice);
  const dispatch = useDispatch();
  const {
    data: energyAssetsData = [],
    energyAssetsError,
    energyAssetsIsLoading,
  } = useGetProtectedApiDataQuery({ url: "energy-assets", lang: languageType });

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(energyAssetsData);
  }, [energyAssetsData]);

  // const getBannerImage = () => {
  //   if (powerTabStr === "thermal") {
  //     return "images/inner_2.png";
  //   } else if (powerTabStr === "solar") {
  //     return "images/inner_3.png";
  //   } else {
  //     return "images/banner_hydro.png";
  //   }
  // };

  const animation = {
    animation: "fadeIn 1s",
  };

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  if (energyAssetsIsLoading) {
    return <Loader />;
  }

  if (energyAssetsError) {
    return <div>Error: {energyAssetsError.message}</div>;
  }
  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        titleLink="/power-generation"
        levelTwo={false}
        levelThree={false}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="power">
            <div className="container">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
                  <ul className="nav nav-pills inner-customtab">
                    <li className="nav-item">
                      <a
                        className={`nav-link ${
                          powerTabStr === "hydro" ? "active" : ""
                        }`}
                        data-bs-toggle="pill"
                        href="#hydro"
                        onClick={() => dispatch(setPowerTabStr("hydro"))}
                      >
                        {getText("Hydro Power", "जल विद्युत")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${
                          powerTabStr === "thermal" ? "active" : ""
                        }`}
                        data-bs-toggle="pill"
                        href="#thermal"
                        onClick={() => dispatch(setPowerTabStr("thermal"))}
                      >
                        {getText("Thermal Power", "ताप विद्युत")}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={`nav-link ${
                          powerTabStr === "solar" ? "active" : ""
                        }`}
                        data-bs-toggle="pill"
                        href="#solar"
                        onClick={() => dispatch(setPowerTabStr("solar"))}
                      >
                        {getText("Solar Power", "सौर ऊर्जा")}
                      </a>
                    </li>
                  </ul>
                  <div
                    className="tab-content"
                    style={animation}
                    key={powerTabStr}
                  >
                    {/* <!--hydro power section end here--> */}

                    {powerTabStr === "hydro" && (
                      <HydroPower energyAssetsData={energyAssetsData} />
                    )}
                    {powerTabStr === "thermal" && (
                      <ThermalPower energyAssetsData={energyAssetsData} />
                    )}
                    {powerTabStr === "solar" && (
                      <SolarPower energyAssetsData={energyAssetsData} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PowerGeneration;
